import { render, staticRenderFns } from "./LeadsStorage.vue?vue&type=template&id=6a52e8d6&scoped=true"
import script from "./LeadsStorage.vue?vue&type=script&lang=js"
export * from "./LeadsStorage.vue?vue&type=script&lang=js"
import style0 from "./LeadsStorage.vue?vue&type=style&index=0&id=6a52e8d6&prod&lang=css"
import style1 from "./LeadsStorage.vue?vue&type=style&index=1&id=6a52e8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52e8d6",
  null
  
)

export default component.exports